<template>

    <transition
            name="exposure-fade"
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            appear>

        <div class="exposure-wrapper">

            <!-- HEADER -->
            <div class="header" :style="{ backgroundColor: cssPropColor('$color-primary') }">
                <span class="icon">
                    <label title="Close" @click="closeExposure"><i class="icon-MBR_close" aria-hidden="true"></i></label>
                </span>
                <span class="label" v-html="headerLabel"></span>
            </div>
            <!-- END HEADER -->

            <!-- CONTENT -->
            <div class="exposure-content">

                <!-- LEAD-IN -->
                <div class="lead-in" v-html="content.lead_in" v-if="content.lead_in"></div>
                <!-- END LEAD-IN -->

                <!-- MEDIA -->
                <div class="media" v-if="(content.media.sources.length)">

                    <div class="image-carousel" v-if="(content.media.type === 'images')">
                        <!-- IMAGE(S) -->
                        <img v-for="(image, idx) in content.media.sources" :src="image" :key="idx" alt="" />
                        <!-- END IMAGE(S) -->
                    </div>

                    <div class="video-player" v-if="(content.media.type === 'video')">
                        <!-- VIDEO -->
                        <div class="player">
                            <video id="video-player" :src="content.media.sources[0]" playsinline autoplay muted loop controlsList="nodownload">
                                <!--source v-if="content.media.sources[0]" :src="content.media.sources[0]" :type="videoType" /-->
                                Your browser does not support HTML5 video.
                            </video>
                        </div>
                        <!-- END VIDEO -->
                    </div>

                </div>
                <!-- END MEDIA -->

                <!-- BODY -->
                <div class="body">
                    <div class="inner">

                        <!-- LOSS EXAMPLE -->
                        <section v-if="content.loss_example">
                            <h3 :style="{ color: cssPropColor('$color-primary') }">Loss Example</h3>
                            <div v-html="content.loss_example"></div>
                            <hr :style="{ backgroundColor: cssPropColor('$color-divider') }" />
                        </section>
                        <!-- END LOSS EXAMPLE -->

                        <!-- MAINTENANCE TIP -->
                        <section v-if="content.maintenance_tip">
                            <h3 :style="{ color: cssPropColor('$color-primary') }">Maintenance Tip</h3>
                            <div v-html="content.maintenance_tip"></div>
                            <hr :style="{ backgroundColor: cssPropColor('$color-divider') }" />
                        </section>
                        <!-- END MAINTENANCE TIP -->

                        <!-- PDF -->
                        <section v-if="content.pdf">
                            <span class="icon"><i class="icon-MBR_download" aria-hidden="true"></i></span>
                            <a v-bind:href="content.pdf" @click="trackEvent('PDF Download', content.pdf)" title="Download PDF" target="_blank">Download PDF</a>
                            <hr style="margin-bottom: 0;" :style="{ backgroundColor: cssPropColor('$color-divider') }" />
                        </section>
                        <!-- END PDF -->

                        <div class="related" v-if="(service || premise)">

                            <div class="cta-text" v-if="(premise)" v-html="coverageContent.cta_offpremise"></div>
                            <button class="btn" :style="{ backgroundColor: cssPropColor('$color-secondary') }" v-if="(premise)" @click="togglePanel(addCoverageLabel, 'off-premise', false)" v-html="labelOffPremise" :title="labelOffPremise"></button>

                            <div class="cta-text" v-if="(service)" v-html="coverageContent.cta_serviceline"></div>
                            <button class="btn" :style="{ backgroundColor: cssPropColor('$color-secondary') }" v-if="(service)" @click="togglePanel(addCoverageLabel, 'service-line', false)" v-html="labelServiceLine" :title="labelServiceLine"></button>

                            <hr />

                        </div>

                    </div>
                </div>
                <!-- END BODY -->

                <exposures-carousel :selectedSlug="slug"></exposures-carousel>

            </div>
            <!-- END CONTENT -->

        </div>

    </transition>

</template>


<script>

    import ExposuresCarousel from "./ExposuresCarousel.vue";

    let vm = {};

    export default {

        name: 'mobile-content-exposure',

        props: [
            'panel',
            'slug',
            'service',
            'premise'
        ],

        components: { ExposuresCarousel },

        data() {
            return {
                carousel: false,
                contact: {
                    text: 'Ready to take the next step?',
                    link: {
                        label: 'Contact us today'
                    }
                },
                videoType: 'video/mp4'
            }
        },

        computed: {

            content() {
                return this.$dataStore.getters.getExposureBySlug(this.slug);
            },

            disclaimer() {
                return this.$dataStore.getters.getExposureDisclaimer;
            },

            headerLabel() {
                let _l = this.content.exposure_label,
                    _s = this.content.exposure_slug,
                    _c = this.content.coverage,
                    _t = this.content.exposure_type;

                if (_s === 'laptop' && _t === 'off-premise' && _c) {
                    return this.labelOffPremise + ': ' + _l;
                }

                return _l;
            },

            addCoverageLabel() {
                return this.$dataStore.getters.getAdditionalCoveragesLabel;
            },

            coverageContent() {
                return this.$dataStore.getters.getCoverageContent;
            },

            labelOffPremise() {
                return this.$dataStore.getters.getOffPremiseCoverageLabel;
            },

            labelServiceLine() {
                return this.$dataStore.getters.getServiceLineCoverageLabel;
            },

            videoSource() {
                return '<source src="' + this.content.media.sources[0] + '" type="' + this.videoType + '" />';
            }

        },

        created() {
            console.info('%cmobile-content-exposure::created', 'color:dodgerblue;');
        },

        mounted() {
            console.info('%cmobile-content-exposure::mounted', 'color:green;');

            console.log('this.content', this.content);

            this.$eventBus.$emit('footer:disclaimer:show');

            vm = this;

            // play video if we gotz one
            if (vm.content.media.type === 'video') {
                setTimeout(function() {
                    vm.playVideo();
                }, 2000);
            }

            // init carousel if we gotz images
            if (vm.content.media.type === 'images') {
                setTimeout(function() {
                    vm.initCarousel();
                }, 100);
            }

        },

        methods: {

            playVideo() {
                let _video      = $('#video-player'),
                    _videoEl    = _video[0];

                // video `canplay` event handler
                _video.on('canplay', function() {
                    _video.trigger('play');
                });

                // check `readyState` in case video element has already been init'd/cached
                if (_videoEl.readyState > 3) {
                    _video.trigger('play');
                }
            },

            initCarousel() {
                vm.carousel = true;
                $('.image-carousel').slick({
                    infinite: false,
                    arrows: false,
                    slideToScroll: -1,
                    adaptiveHeight: true,
                    variableWidth: true,
                    waitForAnimate: false
                });
            },

            trackEvent(action, label) {
                gtag('event', action, {
                    'event_category': 'MBRe: Residential',
                    'event_label': label || ''
                });
            },

            closeExposure() {
                this.$eventBus.$emit('exposure:closed');
            },



            /**
             * @method togglePanel
             * @description
             * @param {String} tab
             * @param {String} type
             * @param {Boolean} opt
             */
            togglePanel(tab, type, opt) {
                type = type || null;
                this.$eventBus.$emit('tab:change', tab, type, opt);
            },

            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            }

        },

        events: {

        },

        beforeDestroy() {

            this.$eventBus.$emit('footer:disclaimer:hide');

            if (vm.carousel) {
                $('.image-carousel').slick('unslick');
            }
        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .exposure-wrapper {
        height: 100%;
        position: relative;
        animation-duration: 0s;
        animation-delay: 0.6s;

        & .header {
            background-color: var(--color-primary);
            color: $white-100;
            line-height: 1;
            height: 50px;
            padding: 17px 16px 16px;
            overflow: hidden;
            display: flex;
            justify-content: center;

            & .icon {
                flex: 0 0 auto;

                & label {
                    width: 100%;
                    height: 100%;
                    margin: 0 0 0 0;

                    &:hover {
                        cursor: pointer;

                        & .fa {
                            opacity: 0.8;
                            transition: all 0.3s $easeInOutQuad;
                        }
                    }

                    & .fa {
                        opacity: 1;
                        transition: all 0.3s $easeInOutQuad;
                    }
                }
            }

            & .label {
                font-family: $font-univers-cond;
                font-size: 1rem;
                text-align: center;
                text-transform: uppercase;
                letter-spacing: 0.7px;
                white-space: nowrap;
                margin: 0 0 0 -17px;
                padding: 0 0 0 0;
                flex: 1 0 auto;
            }
        }
    }

    .exposure-content {

        .lead-in {
            font-family: $font-univers-std;
            font-size: 0.875rem;
            line-height: 1.438;
            text-align: left;
            padding: 1.75rem 1.875rem;
        }

        & .media {

            & .image-carousel {
                line-height: 0;
            }
        }

        & .player {
            line-height: 0;
        }

        video {
            width: 100% !important;
            height: auto !important;
        }

        & .body {
            font-family: $font-univers-std;
            font-size: 0.875rem;
            font-weight: normal;
            line-height: 1.438;
            letter-spacing: 0;
            text-align: left;
            color: rgba(76,76,76, 1.0);

            & > .inner {
                padding: 1.75rem;
            }

            & h3 {
                font-family: $font-univers-bold;
                font-size: 1rem;
                font-weight: normal;
                line-height: 1;
                letter-spacing: 0;
                text-transform: none;
                text-align: left;
                margin: 0 0 12px 0;
            }

            & a {
                color: var(--color-primary);
                text-decoration: underline;
            }

            & .icon {
                font-size: 1.5rem;
                vertical-align: middle;
            }
        }

        & .contact-link {
            font-family: $font-univers-std;
            font-size: 0.875rem;
            font-weight: normal;
            line-height: 1.438;
            letter-spacing: 0;
            text-align: center;
            padding: 0 0 2rem;
        }

        & .disclaimer {
            font-family: $font-univers-std;
            font-size: 0.688rem;
            font-weight: normal;
            line-height: 1.375;
            letter-spacing: 0;
            text-align: left;
            padding: 1rem 0 0;
        }

        & .related {
            text-align: center;

            & .cta-text {
                margin: 0 0 1rem 0;
            }

            & hr {
                margin-bottom: 0.25rem;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// MobileContentExposure.vue?129896ff